import React from "react";
import { Carousel } from "react-bootstrap";

const PortfolioCarousel = ({ item, ...props }) => {
  return (
    <Carousel {...props}>
      {item && item.images.map((image, index) => {
        return (
          <Carousel.Item key={index}>
            <img className="d-block w-100 pt-md-5" src={image.src} alt="First slide" />
            <Carousel.Caption key={index} className="d-none d-md-block">
              <div className="row no-gutters">
                <b className="small">
                  {index + 1} of {item.images.length}: {image.caption}
                </b>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default PortfolioCarousel;
